import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCLVYC6rTaFUj1CswO-1rcRKaAWPba2E-k',
  authDomain: 'janatha-hr.firebaseapp.com',
  projectId: 'janatha-hr',
  storageBucket: 'janatha-hr.firebasestorage.app',
  messagingSenderId: '277645480916',
  appId: '1:277645480916:web:24e48f2d89cc6d616ffc41',
  measurementId: 'G-WWNLZ0RS6R',
};

// Cloud Functions are deployed to Mumbai; callers must ask for the same region
// or callables resolve to us-central1 and 404.
export const FUNCTIONS_REGION = 'asia-south1';

export const app = initializeApp(firebaseConfig);

// Firestore is the only SDK the public site needs, so it is the only one
// imported eagerly. Auth, Functions and Storage live in firebase-admin-sdk.js
// and load with the admin area. Everything talks to the live janatha-hr
// project; local development shares one database with production.
export const db = getFirestore(app);

export const analyticsReady = import.meta.env.DEV
  ? Promise.resolve(null)
  : isSupported().then((ok) => (ok ? getAnalytics(app) : null));
